import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile'
import {isMobile,browserName,browserVersion, osName,osVersion} from 'react-device-detect'
import uuid from 'uuid';

class Signout extends Component {
    constructor() {
        super();

        this.state = {
            is_loaded: false
        }
    }

    componentDidMount() {
        config.AuthManager.signout();
        var p = new UserProfile();

        var varPageEvent = '';
        var varUserIP = '';
        var varUserEmail = '';        
        var varCurrentPage = '';
        var varCurrentDateTime = '';
        var varIsAcumenAdmin = '';
        var varIsCustomerAdmin = '';
        var varCustomerId = '';
        var varUserId = '';
        var varIsMobile = '';
        var varScreenWidth = '';
        var varScreenHeight = '';
        var varBrowserName = '';
        var varBrowserVersion = '';
        var varOSName = '';
        var varOSVersion = '';
        var varSessionID = '';
    
    //PageEvent
    var varPageEvent = 'PAGEVIEW';
    //ip address
    if(sessionStorage.getItem("session_ipaddress") === null)        
    {
        fetch('https://api.ipify.org').then(response => response.text()).then((data)=>{sessionStorage.setItem('session_ipaddress',data)});         
    }
    else
    {            
        varUserIP =  sessionStorage.getItem("session_ipaddress");
    }        
    //email address           
    varUserEmail = p.Email();
    //CurrentPage
    varCurrentPage = window.location.href;
    //CurrentDateTime
    varCurrentDateTime = Date.now();
    //IsAcumenAdmin
    varIsAcumenAdmin = p.IsAcumenAdmin();
    //IsCustomerAdmin
    varIsCustomerAdmin = p.IsCustomerAdmin();
    //CustomerId
    varCustomerId = p.CustomerId();
    //UserId
    varUserId = p.UserId();
    //IsMobile
    varIsMobile = isMobile;
    //varScreenWidth
    varScreenWidth = window.innerWidth;
    //varScreenHeight
    varScreenHeight = window.innerWidth;
    varBrowserName = browserName;
    varBrowserVersion = browserVersion;
    varOSName = osName;
    varOSVersion = osVersion;
    if(sessionStorage.getItem("session_id") === null)        
    {           
        sessionStorage.setItem('session_id',uuid.v4());  
        varSessionID = sessionStorage.getItem("session_id");     
    }
    else
    {            
        varSessionID =  sessionStorage.getItem("session_id");
    }                

    console.log('session_id: ' + varSessionID); 
    console.log('varPageEvent: ' + varPageEvent);
    console.log('varUserIP: ' + varUserIP);
    console.log('varUserEmail: ' + varUserEmail);       
    console.log('varCurrentPage: ' + varCurrentPage);
    console.log('varCurrentDateTime: ' + varCurrentDateTime );
    console.log('varIsAcumenAdmin: ' + varIsAcumenAdmin);
    console.log('varIsCustomerAdmin: ' + varIsCustomerAdmin);
    console.log('varCustomerId: ' + varCustomerId);
    console.log('varUserId: ' + varUserId);
    console.log('varIsMobile: ' + varIsMobile);
    console.log('varScreenWidth: ' + varScreenWidth);
    console.log('varScreenHeight: ' + varScreenHeight);
    console.log('varBrowserName: ' + varBrowserName);
    console.log('varBrowserVersion: ' + varBrowserVersion);
    console.log('varOSName: ' + varOSName);
    console.log('varOSVersion: ' + varOSVersion);

    var UserMetric = {            
        "PageEvent" : varPageEvent,
        "UserIP" : varUserIP,
        "UserEmail" : varUserEmail,
        "CurrentPage" : varCurrentPage,
        "CurrentDateTime" : varCurrentDateTime,
        "IsAcumenAdmin" : varIsAcumenAdmin,
        "IsCustomerAdmin" : varIsCustomerAdmin,
        "CustomerId" : varCustomerId,
        "UserId" : varUserId,
        "IsMobile" : varIsMobile,
        "ScreenWidth" : varScreenWidth,
        "ScreenHeight" : varScreenHeight,
        "BrowserName" : varBrowserName,
        "BrowserVersion" : varBrowserVersion,
        "OSName" : varOSName,
        "OSVersion" : varOSVersion,
        "SessionID" : varSessionID
    };

    
        let method = 'post';
        let uri = config.getUriPath('usermetric');
        let h = config.ApiHeaders();        
        fetch(uri, {
            method: method,
            headers: h,
            body: JSON.stringify(UserMetric)
        }).then(function(response) {
        if (response.status >= 400) {
          console.log(response);
          throw new Error("Bad response from server");
        }              
        });


        p.signout();

        this.setState({is_loaded: true});
    }
            
    render() {
        if (this.state.is_loaded === false){
            return <div></div>
        }       

        // return <Redirect to="/" />
        return window.location ='/login';
    }
}

export default Signout


// WEBPACK FOOTER //
// ./src/Components/Shared/Signout.js